
import React from 'react';
import { useLocation } from 'react-router-dom';

const PricingPageBypass: React.FC = () => {
  const location = useLocation();
  
  // Check if we're on the pricing page
  if (location.pathname === '/pricing') {
    console.log('🟢 PricingPageBypass: COMPLETE BYPASS for pricing page detected at:', new Date().toISOString());
    return null;
  }
  
  // For any other page, return null to let the app continue rendering
  return null;
};

export default PricingPageBypass;
